import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Image, Input, Typography } from "antd";
import { useAuth } from "authentication";
import AppNotificationContainer from "components/AppNotificationContainer";
import LoginLoading from "components/Modal/LoginLoading";
import { useSelector } from "react-redux";
import AppConfig from "utils/Config";

const SignIn = () => {
  const { isLoading, userLogin } = useAuth();
  const { loading, message, error } = useSelector(({ common }) => common);

  const { Title } = Typography;

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = async (values) => {
    // await userLogin({ username, password, remember });
    await userLogin(values);
  };

  const initialValues = {
    username: "",
    password: "",
    remember: false,
  };

  return (
    <div className="login_container bg-gray-100">
      <section>
        <div className="header_img">
          <Image src={AppConfig.logo} alt="logo" preview={false} width={120} />
        </div>
        <div className="gx-app-login-wrap">
          <div className="gx-app-login-container">
            <div className="gx-app-login-main-content">
              <div className="gx-app-logo-content d-sm-none">
                <div className="gx-app-logo-content-bg">
                  <img
                    src={AppConfig.logInImage}
                    alt="login banner"
                    className="gx-img-fluid"
                  />
                </div>
              </div>
              <div className="gx-app-login-content">
                <Title level={4}>{AppConfig.appName} Login</Title>
                <Form
                  name="basic"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  className="gx-signin-form"
                  initialValues={initialValues}
                >
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "The input is not valid username!",
                      },
                    ]}
                    name="username"
                  >
                    <Input
                      placeholder="Username"
                      prefix={
                        <UserOutlined style={{ background: "#ffffff" }} />
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                    name="password"
                  >
                    <Input.Password
                      prefix={
                        <LockOutlined style={{ background: "#FAFAFF" }} />
                      }
                      type="password"
                      placeholder="Password"
                    />
                  </Form.Item>
                  <div className="flex justify-between items-center mb-2">
                    <Form.Item
                      name="remember"
                      valuePropName="checked"
                      className="gx-ml-2 mb-0"
                    >
                      <Checkbox>
                        <span className="gx-signup-form-forgot fs_16">
                          Remember me
                        </span>
                      </Checkbox>
                    </Form.Item>
                    <a href="/forgot-password" className="text-blue-500 text-sm">
                      Forgot Password?
                    </a>
                  </div>
                  <Button type="primary" block htmlType="submit">
                    Login
                  </Button>
                </Form>
                <p className="text-center">
                  Don’t have account?{" "}
                  <a href={AppConfig.adminMailNewAccount}>Contact Our Admin</a>
                </p>
              </div>
              <AppNotificationContainer
                loading={isLoading}
                error={error}
                message={message}
              />
            </div>
          </div>

          <small className="gx-text-center gx-mt-3 login_desc">
            {AppConfig.tagLine}
          </small>
        </div>
      </section>
      <div className="footer_img">
        <img src={AppConfig.spiral} alt="spiral design" />
      </div>
      {loading && <LoginLoading showModal={loading} />}
    </div>
  );
};

export default SignIn;
